import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from "react";
import moment from "moment";
import { replaceMultiple } from "@/utils/funcs";
import { useAppSelector } from "@/hooks/store";
import { getCurrentUserDateFormat } from "@/store/utils/selectors/userSelector";
/**
 * Format de date par défaut
 */
export var defaultDateFormat = "DD/MM/YYYY";
/** <b>Composant en mode consultation/detail d'un champ de type Date</b>*/
export default function DateFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record, _b = _a.format, format = _b === void 0 ? defaultDateFormat : _b;
    /*
    const { data: queryResult } = useGetCurrentUserQuery(null);
    const user_preferences = queryResult?.data?.preferences?.date;
    const dateFormat = user_preferences?.date_format;
    */
    var dateFormat = useAppSelector(getCurrentUserDateFormat);
    var replacements = { m: "MM", i: "mm", Y: "y", d: "DD" };
    var formatDate = useMemo(function () { return "".concat(dateFormat) || format; }, [format]);
    var value = useMemo(function () {
        if (!record) {
            return "";
        }
        return record[fieldName || ""] || "";
    }, [record]);
    var momentDate = useMemo(function () { return moment(value); }, [value]);
    var date = useMemo(function () {
        return momentDate.isValid()
            ? momentDate.format(replaceMultiple(formatDate, replacements))
            : "";
    }, [momentDate, formatDate]);
    return (_jsx(_Fragment, { children: _jsx("span", { children: date }) }));
}
